<template>
  <div
    class="row f-row bdr-l bdr-r"
    style="height: 2.2rem; background: var(--darkbackground2);"
  >
    <div
      class="col d-flex align-items-center"
      :class="showToggle ? 'col-8' : 'col-10'"
    >
      <div class="col col-auto ml-2 mr-1" v-if="componentSubTitle != null">
        {{ componentSubTitle }}
      </div>
      <div
        v-if="showAssetTypeDD"
        class="col col-auto text-left mr-1"
        style="z-index: 10000!important;"
      >
        <Dropdown
          v-model="selectedAssetType"
          :options="assetTypes"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select Asset"
          scrollHeight="400px"
          @change="onSelectedAssetType"
        >
          <template #value="slotProps">
            {{ assetTypes[slotProps.value].asset }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <template v-if="showAssetDD">
        <div
          class="col col-auto text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 0"
        >
          <Dropdown
            v-model="selectedAsset0"
            :options="
              currencySpecs.map((d, i) => {
                return { asset: d.currency_name, id: i };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Currency"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ currencySpecs[slotProps.value].currency_name.toUpperCase() }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          :class="spreadAsset2 == null ? 'col-auto' : 'col-6'"
          :style="{ maxWidth: showAssetTypeDD ? '30%' : 'auto' }"
          class="col ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 1"
        >
          <span v-if="showLoadingComm" class="text-right">
            <QSLoading
              :isLoading="showLoadingComm"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset1"
            :options="
              commoditySpecs.map((d, i) => {
                return { asset: d.fk_idproduct.toUpperCase(), id: i };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Commodity"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ commodityString(slotProps.value) }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="col col-auto ml-1 mr-1 text-left" v-show="isSpread">
          vs
        </div>
        <div
          v-show="isSpread"
          class="col col-5 ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
        >
          <span v-if="showLoadingComm" class="text-right">
            <QSLoading
              :isLoading="showLoadingComm"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="spreadAsset2"
            :options="
              commoditySpecs.map((d, i) => {
                return { asset: d.fk_idproduct.toUpperCase(), id: i };
              })
            "
            @change="onUserAsset2Selection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Commodity"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ commodityString(slotProps.value) }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-auto ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 2"
        >
          <span v-if="showLoadingIR" class="text-right">
            <QSLoading
              :isLoading="showLoadingIR"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset2"
            :options="
              irSpecs.map((d, i) => {
                return {
                  asset: d.interest_rate_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Interest Rate"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{
                verySmall
                  ? irSpecs[slotProps.value].interest_rate_name
                  : irSpecs[slotProps.value].long_name
              }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-auto h-100 txt-label-primary-2"
          v-show="selectedAssetType === 2"
        >
          <HoverMultiSelection
            :btnWidth="'2.5rem'"
            :options="irAvailableTerms"
            :selected="irSelectedTerm"
            @eventOnChangeOption="(opt) => onChangeTerm(opt.value)"
          />
        </div>
        <div
          class="col col-auto ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 3"
        >
          <span v-if="showLoadingInd" class="text-right">
            <QSLoading
              :isLoading="showLoadingInd"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset3"
            :options="
              indexSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Index"
            scrollHeight="400px"
            :filter="true"
            :loading="indexSpecs === null || indexSpecs === undefined"
          >
            <template #value="slotProps">
              <span v-if="hasValidSelection(slotProps.value)">
                {{
                  verySmall
                    ? getShortName(slotProps.value)
                    : getLongName(slotProps.value)
                }}
              </span>
              <span v-else>Select Index</span>
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-auto ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 4"
        >
          <span v-if="showLoadingFut" class="text-right">
            <QSLoading
              :isLoading="showLoadingFut"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset4"
            :options="
              futuresSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Future"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{
                verySmall
                  ? futuresSpecs[slotProps.value].short_name
                  : futuresSpecs[slotProps.value].long_name
              }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-auto ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-show="selectedAssetType === 5"
        >
          <span v-if="showLoadingETF" class="text-right">
            <QSLoading
              :isLoading="showLoadingETF"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset5"
            :options="
              etfSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select ETF"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{
                verySmall
                  ? etfSpecs[slotProps.value].short_name
                  : etfSpecs[slotProps.value].long_name
              }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
      </template>
      <!-- Multi selector of commodities -->
      <template v-if="showAssetMultiSelect">
        <div
          class="col col-auto ml-1 mr-1 text-left"
          style="z-index: 10000!important;"
          v-if="selectedAssetType === 1"
        >
          <span v-if="showLoadingComm" class="text-right">
            <QSLoading
              :isLoading="showLoadingComm"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <div class="col col-10">
            <MultiSelect
              v-model="selectedAssetList"
              @change="onUserAssetMultiSelection"
              :options="
                commoditySpecs.map((d, i) => {
                  return {
                    asset: d.fk_idproduct.toUpperCase(),
                    id: d.pk_idcommodity,
                  };
                })
              "
              :filter="true"
              optionLabel="asset"
              placeholder="Select Commodity"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="country-item">
                  <div>{{ slotProps.option.asset }}</div>
                </div>
              </template>
            </MultiSelect>
          </div>
        </div>
      </template>
    </div>
    <div
      class="col d-flex justify-content-end align-items-center"
      :class="showToggle ? 'col-4' : 'col-2'"
    >
      <span
        v-if="showToggle"
        class="ml-1 mr-3"
        style="margin-top: 5px!important;"
      >
        <ToggleButton
          :id="componentNumber + '_button'"
          :defaultState="false"
          :labelEnableText="'- Fields'"
          :labelDisableText="'+ Fields'"
          v-on:change="onUserShowFields"
        />
      </span>
      <ButtonClose
        fontSize="18"
        :showBorder="false"
        @btnAbort="onUserClearComponent"
      />
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/buttons/Close";
import Dropdown from "primevue/dropdown";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import QSLoading from "@/components/QSLoading.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import MultiSelect from "primevue/multiselect";

export default {
  name: "AssetSelector",
  props: {
    assetTypes: { required: true, default: () => [] },
    commoditySpecs: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    currentLayout: { required: true, default: () => ({ componentId: null }) },
    etfSpecs: { required: true, default: () => [] },
    futuresSpecs: { required: true, default: () => [] },
    indexSpecs: { required: true, default: () => [] },
    irAvailableTerms: { required: true, default: () => [] },
    irSpecs: { required: true, default: () => [] },
    isSpread: { required: false, type: Boolean, default: false },
    showFields: { required: false, type: Boolean, default: false },
    showLoadingComm: { required: true, type: Boolean, default: false },
    showLoadingETF: { required: true, type: Boolean, default: false },
    showLoadingFut: { required: true, type: Boolean, default: false },
    showLoadingInd: { required: true, type: Boolean, default: false },
    showLoadingIR: { required: true, type: Boolean, default: false },
    stopAssetType: { required: true, type: Boolean, default: false },
    verySmall: { required: false, type: Boolean, default: false },
    // =======================================
    userAssetType: { required: true, default: 1 },
    userSelectedAsset: { required: true, default: null },
    userSelectedAsset2: { required: true, default: null },
    userSelectedTerm: { required: true, default: null },
    // =======================================
    colorTheme: { required: true, type: Boolean, default: true },
    componentNumber: { required: true, default: 1 },
  },
  components: {
    ButtonClose,
    Dropdown,
    HoverMultiSelection,
    QSLoading,
    ToggleButton,
    MultiSelect,
  },
  data() {
    return {
      localShowFields: false,
      irSelectedTerm: null,
      selectedAsset0: 3,
      selectedAsset1: 3,
      selectedAssetList: [{ asset: "BRENT", id: 3 }], // Default selection with PK
      selectedAsset2: 3,
      selectedAsset3: 9,
      selectedAsset4: 7,
      selectedAsset5: 4,
      selectedAssetType: 1,
      spreadAsset2: null,
    };
  },
  computed: {
    showAssetTypeDD() {
      let showADD = false;
      let selectedComponent = this.currentLayout.componentId;
      if (selectedComponent == "technicalChart") {
        showADD = true;
      }
      return showADD;
    },
    showAssetDD() {
      let showADD = true;
      let selectedComponent = this.currentLayout.componentId;
      if (
        selectedComponent == "currencySpotTable" ||
        selectedComponent == "assetsTable" ||
        selectedComponent == "currencyForward" ||
        selectedComponent === "commodityTable"
      ) {
        showADD = false;
      }
      return showADD;
    },
    showAssetMultiSelect() {
      let showAMS = false;
      let selectedComponent = this.currentLayout.componentId;
      if (selectedComponent === "commodityTable") {
        showAMS = true;
      }
      return showAMS;
    },
    showToggle() {
      let showT = true;
      let selectedComponent = this.currentLayout.componentId;
      if (
        selectedComponent == "technicalChart" ||
        selectedComponent == "commFuturesChart"
      ) {
        showT = false;
      }
      return showT;
    },
    componentSubTitle() {
      let title = "Component title";
      let selectedComponent = this.currentLayout.componentId;
      if (selectedComponent == "technicalChart") {
        title = "Technical analysis for";
      } else if (selectedComponent == "commFuturesChart") {
        title = "Futures chart for";
      } else if (selectedComponent == "commodityTable") {
        title = "Futures data for";
      } else if (selectedComponent == "commoditySpread") {
        title = null;
      } else if (selectedComponent == "currencySpotTable") {
        title = "Currencies";
      } else if (selectedComponent == "assetsTable") {
        title = "Int Rates / Credit / Index / ETFs / Futures";
      } else if (selectedComponent == "currencyForward") {
        title = "Currencies forward and Volatility for";
      }
      return title;
    },
  },
  watch: {
    userAssetType(val) {
      this.selectedAssetType = val;
      if (!this.stopAssetType) this.onUserAssetSelection();
    },
    userSelectedAsset() {
      this.userSelectedAssetMethod();
    },
    userSelectedAsset2(val) {
      this.spreadAsset2 = val ?? this.spreadAsset2;
    },
    userSelectedTerm(val) {
      this.irSelectedTerm = val;
      this.onChangeTerm(this.irSelectedTerm);
    },
  },
  created() {
    this.selectedAssetType = this.userAssetType;
  },
  mounted() {
    this.spreadAsset2 = this.userSelectedAsset2;
    this.userSelectedAssetMethod();
  },
  methods: {
    hasValidSelection(id) {
      return id != null && this.indexSpecs && this.indexSpecs[id];
    },
    getShortName(id) {
      return this.indexSpecs[id]?.short_name || "";
    },
    getLongName(id) {
      return this.indexSpecs[id]?.long_name || "";
    },
    commodityString(selectedCommodity) {
      const cmdtyDefs = this.commoditySpecs?.[selectedCommodity];

      if (!cmdtyDefs) return "";

      const name = cmdtyDefs.commodity_name || "";
      const currency = cmdtyDefs.is_cents
        ? "USc"
        : cmdtyDefs.fk_idcurrency || "";
      const unit = cmdtyDefs.fk_idunit || "";

      return `${name} (${currency}/${unit})`;
    },
    userSelectedAssetMethod() {
      let isNull =
        this.userSelectedAsset === null || this.userSelectedAsset === undefined;
      if (this.selectedAssetType === 0) {
        this.selectedAsset0 = this.userSelectedAsset ?? this.selectedAsset0;
      } else if (this.selectedAssetType === 1) {
        // Handle both Dropdown and MultiSelect
        if (this.showAssetMultiSelect) {
          const raw = this.userSelectedAsset;

          const userAssetArray =
            typeof raw === "number"
              ? raw
                  .toString()
                  .split(",")
                  .map(Number)
              : raw;

          const filteredAssets = this.commoditySpecs
            .filter((d) => userAssetArray?.includes(d.pk_idcommodity))
            .map((d) => ({
              asset: d.fk_idproduct.toUpperCase(),
              id: d.pk_idcommodity,
            }));

          if (filteredAssets.length > 0) {
            this.selectedAssetList = filteredAssets;
          }
        } else {
          this.selectedAsset1 = this.userSelectedAsset ?? this.selectedAsset1;
        }
      } else if (this.selectedAssetType === 2) {
        this.selectedAsset2 = this.userSelectedAsset ?? this.selectedAsset2;
        this.irSelectedTerm = isNull
          ? this.irSelectedTerm
          : this.irAvailableTerms.find(
              (d) => d.value === this.userSelectedAsset.term,
            );
      } else if (this.selectedAssetType === 3) {
        this.selectedAsset3 = this.userSelectedAsset ?? this.selectedAsset3;
      } else if (this.selectedAssetType === 4) {
        this.selectedAsset4 = this.userSelectedAsset ?? this.selectedAsset4;
      } else if (this.selectedAssetType === 5) {
        this.selectedAsset5 = this.userSelectedAsset ?? this.selectedAsset5;
      }
      if (isNull) {
        this.onUserAssetSelection();
      }
    },
    onSelectedAssetType() {
      this.$emit("eventOnSelectedAssetType", this.selectedAssetType);
    },
    onUserAsset2Selection() {
      const selAsset = this.spreadAsset2;
      this.$emit("eventOnUserAsset2Selection", selAsset);
    },
    onUserAssetSelection() {
      let selAsset = null;
      if (this.selectedAssetType === 0) {
        selAsset = this.selectedAsset0;
      } else if (this.selectedAssetType === 1) {
        selAsset = this.selectedAsset1;
      } else if (this.selectedAssetType === 2) {
        selAsset = this.selectedAsset2;
      } else if (this.selectedAssetType === 3) {
        selAsset = this.selectedAsset3;
      } else if (this.selectedAssetType === 4) {
        selAsset = this.selectedAsset4;
      } else if (this.selectedAssetType === 5) {
        selAsset = this.selectedAsset5;
      }
      this.$emit("eventOnUserAssetSelection", selAsset);
    },
    onUserAssetMultiSelection() {
      const selectedAssetIds = this.selectedAssetList.map((item) => item.id);
      this.$emit("eventOnUserAssetSelectionList", selectedAssetIds);
    },
    onChangeTerm(val) {
      this.$emit("eventOnChangeTerm", val);
    },
    onUserClearComponent() {
      this.$emit("eventOnUserClearComponent", this.componentNumber);
    },
    onUserShowFields() {
      this.$emit("eventOnUserShowFields", this.componentNumber);
    },
  },
};
</script>
<style>
.active .toggle__switch_g::after {
  left: 50%;
  border: 1px solid var(--expo);
  width: 50%;
  background: var(--expo);
  box-shadow: 0 0 1px var(--expo);
}

.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
</style>
